/**
 * The Masonry form id for the market/persona picker. Used by the submit-action
 * override to detect a successful setup submit; unrelated to any other form.
 */
export const SETUP_MARKET_EXPERIENCE_FORM_ID = 'setupMarketExperience$root';

/**
 * sessionStorage key set by the submit-action override on a successful setup
 * submit, and read by RequireMarketAndPersona so the guard passes the SE
 * through to /home on the on-success deeplink instead of bouncing them back
 * to setup.
 *
 * Scoped to the tab (sessionStorage) — matches the demo flow where an SE
 * opens EOS, sets up, and moves through the demo in one session. Not cleared
 * on sign-out; a fresh tab is the intended reset.
 */
export const PERSONA_JUST_SELECTED_STORAGE_KEY =
  'eos.persona-selector.just-selected';

/**
 * sessionStorage key storing a JSON-serialised `string[]` of capability
 * identifiers to hide in the main nav after market/persona setup. Written by
 * the `setupMarketExperienceComplete` action handler; read by
 * `useNavLinksList` to filter the nav links for the session.
 */
export const HIDDEN_CAPABILITIES_STORAGE_KEY =
  'eos.persona-selector.hidden-capabilities';
